import type { OAuthLoginData } from "@/betby/api/types";
import type { PersistedLoginData } from "@/betby/api/types";

export interface HttpRuntimeAuthSnapshot {
  accessToken: string | null;
  refreshToken: string | null;
  expiresTime: number | null;
  userId: number | null;
  productId: number | null;
  businessId: number | null;
  userInfo: Record<string, unknown> | null;
  loginData: PersistedLoginData | null;
  isAuthenticated: boolean;
}

export interface HttpRuntime {
  getAuthSnapshot?: () => HttpRuntimeAuthSnapshot;
  getSessionTicket?: () => string | null;
  getDeviceId?: () => string;
  clearAuth?: () => void;
  applyLoginData?: (data: OAuthLoginData, responseTimestamp?: number) => void;
  onTokenExpired?: (message?: string, title?: string) => void;
  onServerMaintenance?: (message?: string, title?: string) => void;
  onLogin?: () => void;
}

let runtime: HttpRuntime = {};

export function registerHttpRuntime(nextRuntime: Partial<HttpRuntime>): void {
  // 允许认证、设备、宿主等能力按需分批注册，避免初始化顺序互相耦合。
  runtime = { ...runtime, ...nextRuntime };
}

export function getHttpRuntime(): HttpRuntime {
  return runtime;
}

export function resetHttpRuntime(): void {
  runtime = {};
}
